import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import * as dashboard from './types';

const mutations = {
  [dashboard.SET_STATISTICS](state, statistics) {
    state.statistics.isLoading = false;
    if (!statistics.pagination) {
      statistics = {
        content: statistics,
        pagination: {
          totalElements: statistics.length,
          startReverseIndex: statistics.length,
        },
      };
    }
    state.statistics.totalElements = statistics.pagination
      ? statistics.pagination.totalElements
      : statistics.length;
    state.statistics.totalElements = statistics.pagination.totalElements;
    let startIdx = statistics.pagination.startReverseIndex;

    const newData = statistics.content.reduce((p, c) => {
      c.idx = startIdx--;
      c.createdAt = c.createdAt
        ? format(parseISO(c.createdAt), 'yyyy.MM.dd')
        : c.createdAt;

      c.statisticsDate = c.statisticsDate
        ? format(parseISO(c.statisticsDate), 'yyyy.MM.dd')
        : c.statisticsDate;
      p.push(c);
      return p;
    }, []);
    state.statistics.content = newData;
    state.statistics.pagination = statistics.pagination;
  },
};

export default mutations;
